import { createContext, useContext } from "react";

import { TemplateWriterHelper } from "./TemplateWriterHelper.ts";

export const TemplateWriterContext = createContext<TemplateWriterHelper>(
  {} as TemplateWriterHelper
);

export const useTemplateWriterContext = () => useContext(TemplateWriterContext);
